import EditProfileContainer from "../../../../Components/Applications/Users/EditProfile/EditProfileContainer";

const EditProfile = () => {
  return <EditProfileContainer />;
};

export default EditProfile;
